<!-- 講座概要ページ向け体験談一覧 -->
<script setup lang="ts">
  import { usePlanStore } from "~/stores/PlanStore";
  import { PLAN_SUMMARY_REVIEW_SIZE } from "~/consts/contentsConfig";
  import { PlanInfo } from "~/entities/PlanInfo";

  interface Props {
    planInfo: PlanInfo;
  }
  const props = withDefaults(defineProps<Props>(), {
    planInfo: undefined,
  });

  const planStore = usePlanStore();
  planStore.fetchPlanSummaryReviews(1, PLAN_SUMMARY_REVIEW_SIZE, props.planInfo?.id);

  // otherPlans
  const reviews = computed<any>(() => planStore.planSummaryReviews?.reviews);
  const reviewsPath = computed<string>(() => `/plan/${props.planInfo?.id}/reviews`);
</script>

<template>
  <v-sheet v-if="planInfo?.numberOfRate ?? 0 > 0" color="transparent">
    <v-sheet v-for="(review, index) in reviews" :key="index" color="transparent" class="mb-8">
      <OrganismsPlanReviewCard :review="review" />
    </v-sheet>
    <v-sheet color="transparent" class="text-right">
      <v-btn
        class="text-subtitle-1 ml-auto ml-sm-8 px-0 cursor-pointer"
        color="transparent"
        :ripple="false"
        variant="text"
        :to="reviewsPath"
      >
        <span class="text-main-01"
          >すべて表示
          <v-icon icon="$mdiChevronRight" size="large" />
        </span>
      </v-btn>
    </v-sheet>
  </v-sheet>
  <v-sheet v-else color="transparent" class="no_review"> 講座の体験談はまだありません </v-sheet>
</template>

<style lang="scss" scoped>
  .no_review {
    color: rgb(var(--v-theme-monochrome-03)) !important;
  }
</style>
